const api = {
  // —————————— 通用接口 ——————————
  user_login: '/api/web/admin/login', // 用户登录
  code_image: '/api/web/verify/code/image', // 获取图形验证码
  reset_password: '/api/web/admin/reset/password', // 用户修改登录
  file_upload: '/api/file/upload', // 上传文件
  file_download: '/api/file/read', // 下载文件
  file_delete: '/api/file/delete', // 删除文件
  import_template: '/api/import/downloadTemplate', // 导入模板下载
  mqtt_push: '/api/web/mqtt/push', // 前端向后台转发mqtt消息
  mqtt_push2: '/api/web/mqtt/type2/push', // 前端向后台转发mqtt消息（删卡写卡器专用）

  // —————————— GIS地图 ——————————
  map_province_list: '/api/web/orgdepartment/getProvince', // 有效省份列表
  map_province_count: '/api/web/orgdepartment/count', // 有效省份小区电梯统计信息

  // —————————— 小区管理 ——————————
  writer_info: '/api/web/orgdepartment/getWriterInfo', // 写卡器信息
  writer_edit: '/api/web/orgdepartment/updateWriter', // 编辑写卡器
  village_list: '/api/web/orgdepartment/page', // 小区列表
  village_add: '/api/web/orgdepartment/add', // 新增小区
  village_detail: '/api/web/orgdepartment/detail', // 小区详情
  building_list: '/api/web/liftbase/buildingList', // 楼栋列表
  unit_list: '/api/web/liftbase/unitList', // 单元列表
  building_info: '/api/web/liftbase/buildingInfo', // 小区详情-楼栋信息
  org_info: '/api/web/orgdepartment/orgInfo', // 小区详情-统计信息
  lift_info: '/api/web/liftbase/liftByBuilding', // 小区详情-楼栋-电梯信息
  lift_file_list: '/api/web/liftfile/page', // 电梯文件列表
  lift_file_add: '/api/web/liftfile/add', // 新增电梯文件
  lift_file_edit: '/api/web/liftfile/update', // 编辑电梯文件
  lift_file_remove: '/api/web/liftfile/delete', // 删除电梯文件
  lift_file_detail: '/api/web/liftfile/detail', // 电梯文件详情
  lift_file_upload: '/api/file/uploadImg', // 上传电梯文件

  // —————————— IC卡 ——————————
  card_number: '/api/web/iccard/getCardNum', // 获取IC卡号
  card_list: '/api/web/iccard/page', // IC卡列表
  card_add: '/api/web/iccard/add', // 新增IC卡
  card_edit: '/api/web/iccard/update', // 编辑IC卡
  card_delete: '/api/web/iccard/delete', // 删除IC卡
  card_detail: '/api/web/iccard/getDetailInfo', // IC卡详情
  user_card_info: '/api/web/iccard/getByNum', // 根据ic卡号获取信息

  // —————————— 楼层对应关系 ——————————
  floor_rule_list: '/api/web/liftrule/page', // 楼层规则列表
  floor_rule_check: '/api/web/liftrule/check', // 楼层规则检查
  floor_rule_add: '/api/web/liftrule/create', // 新增楼层规则
  floor_rule_edit: '/api/web/liftrule/update', // 编辑楼层规则
  floor_rule_remove: '/api/web/liftrule/delete', // 删除楼层规则
  floor_rule_detail: '/api/web/liftrule/detail', // 楼层规则详情
  floor_rule_select: '/api/web/liftrule/list', // 楼层规则下拉框

  // —————————— 房间列表 ——————————
  room_list: '/api/web/liftroom/page', // 房间列表
  room_add: '/api/web/liftroom/add', // 新增房间
  room_edit: '/api/web/liftroom/update', // 编辑房间
  room_remove: '/api/web/liftroom/delete', // 删除房间
  room_detail: '/api/web/liftroom/detail', // 房间详情
  room_import: '/api/import/importLiftRoom', // 导入房间

  // —————————— 用户管理 ——————————
  owner_list: '/api/web/ownerrooms/page', // 业主列表
  owner_add: '/api/web/ownerrooms/create', // 新增业主
  owner_remove: '/api/web/ownerrooms/handlOwnerRoom', // 删除业主或家人
  owner_detail: '/api/web/ownerrooms/infoByOwner', // 业主详情
  owner_detail_card: '/api/web/ownerrooms/infoByOwner4Owner', // 业主详情，写卡专用
  owner_status: '/api/web/ownerrooms/updateOwnerStatus', // 审核业主
  owner_Type: '/api/web/ownerrooms/updateOwnerType', // 修改业主类型
  owner_export: '/api/export/ownerRoom', // 导出业主
  owner_import: '/api/import/importOwnerRoom', // 导入业主
  owner_select: '/api/web/orgowner/listByOrg', // 业主下拉框
  orgmanager_list: '/api/web/orgmanager/page', // 物业保洁列表
  orgmanager_add: '/api/web/orgmanager/create', // 新增物业保洁
  orgmanager_edit: '/api/web/orgmanager/update', // 编辑物业保洁
  orgmanager_remove: '/api/web/orgmanager/delete', // 删除物业保洁
  orgmanager_info_detail: '/api/web/orgmanager/detail', // 物业保洁基础信息详情
  orgmanager_building_detail: '/api/web/orgmanager/unitDetail', // 物业保洁楼栋单元详情
  orgmanager_export: '/api/export/manager', // 导出物业保洁
  orgmanager_import: '/api/import/importOrgManager', // 导入物业保洁
  owner_floor_list: '/api/web/liftroom/floorList', // 业主楼层列表
  owner_room_list: '/api/web/liftroom/roomList', // 业主房间列表
  owner_code: '/api/web/liftcode/getPassCode', // 业主房间乘梯码
  owner_info: '/api/web/ownerrooms/roomInfo', // 业主基本信息
  family_list: '/api/web/ownerrooms/famByRoom', // 业主家人列表
  family_add: '/api/web/ownerrooms/createMember', // 新增业主家人
  family_edit: '/api/web/ownerrooms/updateMember', // 编辑业主家人
  owner_pic_add: '/api/web/ownerrooms/updateRoomPics', // 业主详情-照片上传
  owner_liftcode_remove: '/api/web/liftcode/delete', // 删除业主乘梯码

  // —————————— 电梯管理 ——————————
  lift_list: '/api/web/liftbase/page', // 电梯列表
  lift_add: '/api/web/liftbase/add', // 新增电梯
  lift_edit: '/api/web/liftbase/update', // 编辑电梯
  lift_remove: '/api/web/liftbase/delete', // 删除电梯
  lift_detail: '/api/web/liftbase/detail', // 电梯详情
  lift_export: '/api/export/liftbase', // 导出电梯
  lift_import: '/api/import/importLiftBase', // 导入电梯
  lift_allSN: '/api/web/liftbase/getAllSn', // 获取所有小区读头
  lift_allGate: '/api/web/liftbase/getAllGate', // 获取所有小区网关
  by_lift_list: '/api/web/credit/recordList', // 乘梯记录
  by_lift_export: '/api/export/creditRecord', // 导出乘梯记录
  lift_num_rule: '/api/web/liftrule/getLiftNumRuleMap', // 电梯组号的规则明细

  // —————————— 账单管理 ——————————
  order_list: '/api/web/order/getOrderList', // 账单列表
  order_export: '/api/export/liftOrder', // 导出账单
  order_detail_list: '/api/web/order/getOrderDetailList', // 账单详情列表

  // —————————— 角色管理 ——————————
  role_list: '/api/web/role/page', // 角色列表
  role_add: '/api/web/role/add', // 新增角色
  role_edit: '/api/web/role/update', // 编辑角色
  role_remove: '/api/web/role/delete', // 删除角色
  role_detail: '/api/web/role/detail', // 角色详情
  role_select: '/api/web/role/list', // 角色下拉框
  role_menu_edit: '/api/web/role/menu/update', // 编辑角色权限
  role_menu_detail: '/api/web/role/menu/update/list', // 角色权限详情

  // —————————— 人员管理 ——————————
  admin_list: '/api/web/admin/page', // 人员列表
  admin_add: '/api/web/admin/add', // 新增人员
  admin_edit: '/api/web/admin/update', // 编辑人员
  admin_detail: '/api/web/admin/detail', // 人员详情

  // —————————— 权限管理 ——————————
  permission_tree: '/api/web/menu/tree', // 权限树
  permission_list: '/api/web/menu/page', // 权限列表
  permission_add: '/api/web/menu/add', // 新增权限
  permission_edit: '/api/web/menu/update', // 编辑权限
  permission_detail: '/api/web/menu/detail', // 权限详情

  // —————————— 操作日志 ——————————
  log_list: '/api/web/log/list' // 操作日志列表
}

export default api



// WEBPACK FOOTER //
// ./src/apiConfig/api.js